var _ = require('underscore');
var React = require("react");
const createReactClass = require("create-react-class");

var PlaceholderForm = require('./PlaceholderForm.jsx');
var RaygunForm = require('./services/RaygunForm.jsx');
var WebhookForm = require('./services/WebhookForm.jsx');
var SlackForm = require('./services/SlackForm.jsx');
var RollbarForm = require('./services/RollbarForm.jsx');
var AirbrakeForm = require('./services/AirbrakeForm.jsx');
var NewRelicAPMForm = require('./services/NewRelicAPMForm.jsx');
var SpeedCurveForm = require('./services/SpeedCurveForm.jsx');

var EditIntegrationForm = createReactClass({
	getInitialState() {
		return {
			panel: ''
		};
	},

	componentDidMount() {
		if (this.props.integration) {
			this.setState({
				panel: this.props.integration.type
			});
		}
	},

	showPanel: function (type) {
		this.setState({
			panel: type
		});
	},

	render() {
		var rowCount = 0;
		const allIntegrations = _.map(this.props.model.AllIntegrations, function (item) {
			return (
				<IntegrationItem
					key={rowCount++}
					integration={item}
					onClick={this.showPanel}
				/>
			);
		}, this);

		let form = null;
		switch (this.state.panel) {
			case 'raygun':
				form = <RaygunForm model={this.props.model} afterSuccess={this.props.afterSuccess} />;
				break;

			case 'webhook':
				form = <WebhookForm model={this.props.model} afterSuccess={this.props.afterSuccess} />;
				break;

			case 'slack':
				form = <SlackForm model={this.props.model} afterSuccess={this.props.afterSuccess} />;
				break;

			case 'rollbar':
				form = <RollbarForm model={this.props.model} afterSuccess={this.props.afterSuccess} />;
				break;

			case 'airbrake':
				form = <AirbrakeForm model={this.props.model} afterSuccess={this.props.afterSuccess} />;
				break;

			case 'newrelicapm':
				form = <NewRelicAPMForm model={this.props.model} afterSuccess={this.props.afterSuccess} />;
				break;

			case 'speedcurve':
				form = <SpeedCurveForm model={this.props.model} afterSuccess={this.props.afterSuccess} />;
				break;

			default:
				form = <PlaceholderForm />;
				break;
		}

		if (this.props.integration) {
			return React.cloneElement(
				form,
				{ integration: this.props.integration }
			);
		}

		return (
			<div className="row">
				<div className="col-sm-4">
					<div className="list-group integration-items">
						{allIntegrations}
					</div>
				</div>
				<div className="col-sm-8">
					{form}
				</div>
			</div>
		);
	}
});

var IntegrationItem = createReactClass({
	render: function () {
		return (
			<button className="list-group-item integration-item"
					onClick={() => this.props.onClick(this.props.integration.type)}>
				<img src={this.props.integration.icon} alt={this.props.integration.name} className="integration-icon"/>
				{this.props.integration.name}
			</button>
		);
	}
});

module.exports = EditIntegrationForm;
